import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface ProjectsInitialStateType {
  data: [{
    designation: string,
    organization: string,
    clients: [],
    vendors: [],
    duration: string,
    location: string,
    teamSize: string,
    description: string,
    workDone: [],
    technologies: []
  }]
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: ProjectsInitialStateType = {
  data: [{
    designation: "",
    organization: "",
    clients: [],
    vendors: [],
    duration: "",
    location: "",
    teamSize: "",
    description: "",
    workDone: [],
    technologies: []
  }],
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getProjects = createAsyncThunk('ProjectsSlice/getProjects', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/projects')
    const data = await response.data.data
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const ProjectsSlice = createSlice({
  name: "ProjectsSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = [ { designation: "", organization: "", clients: [], vendors: [], duration: "", location: "", teamSize: "", description: "", workDone: [], technologies: [] } ]
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getProjects.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getProjects.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getProjects.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getProjects.fulfilled, getProjects.rejected), (state) => {
        state.loading = false
      })
  }
})

const ProjectsThunks = {
  getProjects,
}

export const ProjectsServices = {
  ...ProjectsThunks,
  actions: ProjectsSlice.actions,
}

const ProjectsReducer = ProjectsSlice.reducer
export default ProjectsReducer